import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStylesDuplicateWorkerModal = makeStyles((theme: any) => ({
  modal: {
    '& .MuiDialog-paper': {
      width: '528px',
      maxWidth: '100%',
    },
  },
  modalContentStyleClass: {
    padding: '0px !important',
    overflow: 'hidden !important' as any,
    display: 'flex !important' as any,
    flexDirection: 'column !important' as any,
  },
  workerItem: {
    borderRadius: '12px',
    marginBottom: '16px',
    padding: '16px',
    paddingRight: '44px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    cursor: 'pointer',
    border: `1px solid ${STYLE.COLOR.DIVIDER}`,
    margin: `16px 24px !important`,
  },
  workerHeader: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  fieldsContainer: {
    marginTop: '10px !important',
    width: '100%',
    rowGap: '12px',
  },
  fieldLabel: {
    fontSize: '12px',
    lineHeight: '12px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT2,
    marginBottom: '4px',
  },
  fieldValue: {
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: 500,
    color: STYLE.COLOR.TEXT1,
    wordBreak: 'break-word' as any,
  },
  disabledWorkerItem: {
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  selectedWorkerItem: {
    border: `1px solid ${STYLE.COLOR.ACCENT_PRIMARY}`,
  },
  avatar: {
    width: '42px !important',
    height: '42px !important',
    // borderRadius: "50%",
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
  },
  workerInfo: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '12px',
    flex: 1,
    minWidth: 0,
  },
  name: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    color: STYLE.COLOR.TEXT1,
    wordBreak: 'break-all',
  },
  badgeCode: {
    color: STYLE.COLOR.TEXT2,
    fontWeight: '400 !important',
    fontSize: '14px !important',
  },
  email: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT2,
    wordBreak: 'break-all',
  },
  radio: {
    position: 'absolute !important' as any,
    top: '16px',
    right: '12px',
    padding: '0 !important' as any,
    '& .MuiSvgIcon-root': {
      height: '20px !important',
      width: '20px !important',
    },
  },
  addNewWorkerLinkContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',
  },
  addNewWorkerLink: {
    color: STYLE.COLOR.ACCENT_PRIMARY,
    textDecoration: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  plusIcon: {
    marginRight: '8px',
  },
  proceedButton: {
    width: '100%',
  },
  errorMessage: {
    marginTop: '12px !important',
  },
  loadingMore: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',
  },
  scrollContainer: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  modalActionsStyleClass: {
    justifyContent: 'space-between !important',
  },
}));
